export type VuelidateFormField = Record<string, { $invalid: boolean, $params: any }> & {
  $dirty: boolean
  $error: boolean
  $invalid: boolean
  $model: any
}

export function formFieldErrors (
  formField: VuelidateFormField,
  rules: Array<[string, string]>,
): Array<string> {
  if (!formField?.$dirty) {
    return []
  }

  return rules.reduce((errors: Array<string>, rule: [string, string]) => {
    const [validator, message] = rule
    if (formField[validator].$invalid) {
      errors.push(message)
    }

    return errors
  }, [])
}

export type FormMode = 'creation' | 'edition'
